import uniqueReferrersIcon from "../assets/icons/uniqueReferrers.svg";
import applicationsReceivedIcon from "../assets/icons/applicationsReceived.svg";
import selectionsIcon from "../assets/icons/selections.svg";
import uniqueBishopsIcon from "../assets/icons/uniqueBishops.svg";

export const gridItems = [
  {
    text: "Unique referrers",
    icon: uniqueReferrersIcon,
    count: 0,
    background: "linear-gradient(159.8deg, #ff81a6 8.56%, #d62a5c 92.67%)",
  },
  {
    text: "Total applications received",
    icon: applicationsReceivedIcon,
    count: 0,
    background: "linear-gradient(152.02deg, #9395fe 6.78%, #5a5cd7 92.59%)",
  },
  {
    text: "Successful selections",
    icon: selectionsIcon,
    count: 14,
    background: "linear-gradient(152.51deg, #48e1ae 7.93%, #08bd80 91.3%)",
  },
  {
    text: "Unique Bishops",
    icon: uniqueBishopsIcon,
    count: 9,
    background: "linear-gradient(152.51deg, #79e148 7.93%, #51d015 91.3%)",
  },
];

export const navigateParametersArray = {
  leaderBoard: [
    "/leaderBoard",
    {
      state: { title: "Referral Leaderboard", mainPage: false },
    },
  ],
};

export const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
